import { csvFormat as csvFormatBrut } from 'd3-dsv'

/* B47 (25/09/2026) : INJECTION DE FORMULE DANS LES EXPORTS CSV.
   Un texte qui commence par = + - @ (ou une tabulation, un retour chariot) est
   pris pour une formule par Excel ou LibreOffice a l'ouverture du fichier. Or
   ces exports contiennent des noms choisis par les utilisateurs eux-memes (un
   candidat a l'inscription, un apprenant dans « Mon compte »). On neutralise
   ces cellules par une apostrophe en tete, la parade usuelle (OWASP, « CSV
   Injection »). Seuls les TEXTES sont touches : un nombre negatif reste un nombre. */
const DEBUT_DE_FORMULE = /^[=+\-@\t\r]/
/* Un nombre pur (« -5 », « +3,5 ») ou le tiret seul des cases vides ne peuvent
   pas etre des formules : on les laisse intacts, sinon l'apostrophe se voit
   dans le tableur (relecture du 25/09 : 1 522 cases « '- » dans un export). */
const INOFFENSIF = /^(-|[-+]?\d+([.,]\d+)?)$/

export const celluleSure = (valeur) => {
  if (valeur === null || valeur === undefined || typeof valeur === 'number' || valeur instanceof Date) return valeur
  // Tout le reste finit en texte dans le fichier (d3-dsv appelle String) : un
  // tableau comme ["=..."] doit donc etre examine sous sa forme texte.
  const texte = String(valeur)
  if (INOFFENSIF.test(texte)) return valeur
  return DEBUT_DE_FORMULE.test(texte) ? "'" + texte : valeur
}

export const csvFormat = (lignes, colonnes) =>
  csvFormatBrut((lignes || []).map((ligne) => {
    const sure = {}
    for (const cle of Object.keys(ligne || {})) sure[cle] = celluleSure(ligne[cle])
    return sure
  }), colonnes)
